import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';
import { BookingTransaction } from '../types/BookingTransaction';

const URL = '/v2/booking-transactions';

class BookingTransactionService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<BookingTransaction>> {
    return axios.get(URL, config);
  }
}

export { BookingTransactionService };
